<div class="dialog-body">
  <h2>Enter Message</h2>

  <input
    type="text"
    [(ngModel)]="message"
    placeholder=""
    class="message-input"
  />

  <div class="actions">
    <button class="send-btn" (click)="submit()">&#9658;</button>
    <button class="cancel-btn" (click)="close()">&#10005;</button>
  </div>
</div>
